var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBloodtype({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#FF6F6F",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.66 2.24713C12.28 1.91713 11.71 1.91713 11.33 2.24713C6.45 6.54713 4 10.2871 4 13.4671C4 18.4471 7.8 21.6671 12 21.6671C16.2 21.6671 20 18.4471 20 13.4671C20 10.2871 17.55 6.54713 12.66 2.24713Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodtype);
export default __webpack_public_path__ + "static/media/bloodtype.b4cd167db21b9d5a8d96a1c963dfc28b.svg";
export { ForwardRef as ReactComponent };